import React, { useState, useCallback, useRef } from 'react';
import { useSelector } from 'react-redux';
import axios from 'axios';
import { CSVLink } from 'react-csv';
import { translator } from '../../utils/Translator';
import querystring from 'querystring';
// import { numberFormat } from '../../../utils/NumberFormat';
import ReactTable from "../ReactTable/TableVisitRouteSticky3";

const MonthlyStock = ({ customerCode, stockFilter }) => {
    const { authUser } = useSelector(({ auth }) => auth);
    const { translate } = useSelector(({ i18n }) => i18n);
    const { languageSelected } = useSelector(({ settings }) => settings);
    const { langFullMonth } = useSelector(({ i18nMaster }) => i18nMaster);
    const { langCustomerFocus } = useSelector(({ i18nCustomerFocus }) => i18nCustomerFocus);
    const { displaySalesHistorySelected, amountSalesHistorySelected, itemGroupSalesHistorySelected
        , productGroupSalesHistorySelected, productLineSalesHistorySelected, productTypeSalesHistorySelected
    } = useSelector(({ customerFocus }) => customerFocus)
    const { productProductGroupFocus, productProductLineFocus, productProductTypeFocus
    } = useSelector(({ product }) => product)

    const [loading, setLoading] = useState(true);
    const [data, setData] = useState([]);
    const [dataTotal, setDataTotal] = useState(0);
    const [pageCount, setPageCount] = useState(0);
    const fetchIdRef = useRef(0);

    const [exportLoading, setExportLoading] = useState(false);
    const [exportData, setExportData] = useState([]);

    const monthData = [
        { value: 1, label: langFullMonth.january },
        { value: 2, label: langFullMonth.february },
        { value: 3, label: langFullMonth.march },
        { value: 4, label: langFullMonth.april },
        { value: 5, label: langFullMonth.may },
        { value: 6, label: langFullMonth.june },
        { value: 7, label: langFullMonth.july },
        { value: 8, label: langFullMonth.august },
        { value: 9, label: langFullMonth.september },
        { value: 10, label: langFullMonth.october },
        { value: 11, label: langFullMonth.november },
        { value: 12, label: langFullMonth.december }
    ];

    const fetchData = useCallback(async ({ sortBy, pageSize, pageIndex }) => {
        // Give this fetch an ID
        const fetchId = ++fetchIdRef.current

        if (fetchId === fetchIdRef.current) {
            // Set the loading state
            setLoading(true);
            setData([]);

            setExportLoading(true);
            setExportData([]);

            let itemgroup = "";
            // if(itemGroupSalesHistorySelected && itemGroupSalesHistorySelected !== null){
            //     itemgroup = itemGroupSalesHistorySelected.value;
            // }
            if (itemGroupSalesHistorySelected && itemGroupSalesHistorySelected.length > 0) {
                itemgroup = itemGroupSalesHistorySelected.map(q => q.value).join(',');
            }

            let productgroup = "";
            // if(productGroupSalesHistorySelected && productGroupSalesHistorySelected !== null){
            //     productgroup = productGroupSalesHistorySelected.value;
            // }
            if (productGroupSalesHistorySelected && productGroupSalesHistorySelected.length > 0) {
                productgroup = productGroupSalesHistorySelected.map(q => q.value).join(',');
            }

            let productline = "";
            // if(productLineSalesHistorySelected && productLineSalesHistorySelected !== null){
            //     productline = productLineSalesHistorySelected.value;
            // }
            if (productLineSalesHistorySelected && productLineSalesHistorySelected.length > 0) {
                productline = productLineSalesHistorySelected.map(q => q.value).join(',');
            }

            let producttype = "";
            if (productTypeSalesHistorySelected && productTypeSalesHistorySelected.length > 0) {
                producttype = productTypeSalesHistorySelected.map(q => q.value).join(',');
            }

            let strFocusGroup = "";
            if (productProductGroupFocus && productProductGroupFocus == true){
                strFocusGroup = "F";
            }else{
                strFocusGroup = "";
            }

            let strFocusLine = "";
            if (productProductLineFocus && productProductLineFocus == true){
                strFocusLine = "F";
            }else{
                strFocusLine = "";
            }

            let strFocusType = "";
            if (productProductTypeFocus && productProductTypeFocus == true){
                strFocusType = "F";
            }else{
                strFocusType = "";
            }

            const pageNumber = pageIndex + 1
            const endRow = pageNumber * pageSize

            const params = {
                company: authUser.company !== "#" ? authUser.company : "",
                customerCode: customerCode,
                language: languageSelected.id,
                display: displaySalesHistorySelected.value,
                itemgroup: itemgroup,
                productgroup: productgroup,
                productline: productline,
                producttype: producttype,
                focusGroup: strFocusGroup ? strFocusGroup : "",
                focusLine: strFocusLine ? strFocusLine : "",
                focusType: strFocusType ? strFocusType : "",
                sortBy: sortBy.length > 0 ? sortBy[0].id : "",
                sort: sortBy.length > 0 ? sortBy[0].desc ? "desc" : "asc" : "",
                page: pageIndex + 1,
                perPage: pageSize,
            }
            let queryString = querystring.stringify(params);
            const url = `${process.env.REACT_APP_API_URL}stockCard/monthly?${queryString}`;

            try {
                const result = await axios(url, { headers: { "Authorization": `Bearer ${localStorage.getItem('x-access-token')}` } });
                const resultData = result.data.data;
                const resultTotal = result.data.total;
                const resultExport = result.data.export;

                setData(resultData);
                setExportData(resultExport);
                setDataTotal(resultTotal);
                setPageCount(Math.ceil(resultTotal / pageSize));

            } catch (error) {
                console.log(error);
            }

            setLoading(false);
            setExportLoading(false);
        }
    }, [authUser, languageSelected, customerCode, displaySalesHistorySelected, itemGroupSalesHistorySelected, productGroupSalesHistorySelected, productLineSalesHistorySelected, productTypeSalesHistorySelected, productProductGroupFocus, productProductLineFocus, productProductTypeFocus]);

    let setColumn = [];
    setColumn.push({
        Header: '',
        id: 'Description',
        sticky: "left",
        columns: [
            {
                Header: () => <div className="text-center font-weight-bold">{displaySalesHistorySelected.label}</div>,
                accessor: 'Description',
                Cell: cellInfo => <div>{cellInfo.row.original.Description} {cellInfo.row.original.Code ? "(" + cellInfo.row.original.Code + ")" : ""} </div>,
                width: 250
            },
        ],
    });

    let headers = [];
    headers.push({
        label: displaySalesHistorySelected.label,
        key: "Description",
    })

    // Fixed period: Jan 2024 to Dec 2025 (24 months)
    const startYear = 2024;
    const endYear = 2025;
    const monthsToShow = [];
    let monthIndex = 1;
    for (let y = startYear; y <= endYear; y++) {
        for (let m = 1; m <= 12; m++) {
            const monthTxt = monthData.find(md => md.value === m)?.label || '';
            const fullDate = `${monthTxt} ${y}`;
            const monthColumnDB = ("0" + monthIndex).slice(-2);
            monthsToShow.push({ fullDate, monthColumnDB, monthNum: m });
            monthIndex++;
        }
    }

    monthsToShow.forEach(({ fullDate, monthColumnDB }) => {
        setColumn.push({
            Header: () => <div className="text-center font-weight-bold">{fullDate}</div>,
            id: monthColumnDB,
            columns: [
                {
                    Header: () => <div className="text-center font-weight-bold">{langCustomerFocus.forward}</div>,
                    accessor: `Month${monthColumnDB}OpenQty`,
                    Cell: row => <div className="text-right">{row.value || 0}</div>,
                    width: 80,
                },
                {
                    Header: () => <div className="text-center font-weight-bold">{langCustomerFocus.buy}</div>,
                    accessor: `Month${monthColumnDB}StockInQty`,
                    Cell: row => <div className="text-right">{row.value || 0}</div>,
                    width: 80,
                },
                {
                    Header: () => <div className="text-center font-weight-bold">{langCustomerFocus.sale}</div>,
                    accessor: `Month${monthColumnDB}StockOutQty`,
                    Cell: row => <div className="text-right">{row.value || 0}</div>,
                    width: 80,
                },
            ],
        })

        headers.push({
            label: `${langCustomerFocus.forward} (${fullDate})`,
            key: `Month${monthColumnDB}OpenQty`,
        })

        headers.push({
            label: `${langCustomerFocus.buy} (${fullDate})`,
            key: `Month${monthColumnDB}StockInQty`,
        })

        headers.push({
            label: `${langCustomerFocus.sale} (${fullDate})`,
            key: `Month${monthColumnDB}StockOutQty`,
        })
    });

    const columns = React.useMemo(() => setColumn, [setColumn, displaySalesHistorySelected, langCustomerFocus]);

    return (
        <div style={stockFilter === 'monthly' ? { display: 'block' } : { display: 'none' }} >
            {(exportLoading === false && loading === false) &&
                <CSVLink
                    data={exportData}
                    headers={headers}
                    filename={`${translator(translate.ISA_MonthlyStock, "ยอดระบาย (รายเดือน)")}.csv`}
                    className="jr-btn jr-btn-lg bg-green text-white mb-4 text-center float-right"
                    style={{ width: 180 }}
                >
                    <i className="zmdi zmdi-grid" />
                    <span>{translator(translate.ISA_ExportDataEN, "Export ข้อมูล")}</span>
                </CSVLink>
            }

            <ReactTable
                columns={columns}
                data={data}
                dataTotal={dataTotal}
                fetchData={fetchData}
                loading={loading}
                initialSortBy={[{ id: "Month24StockOutQty", desc: true }]}  // Adjusted for 24 months
                pageCount={data.length}
            />
        </div>
    )
};

export default MonthlyStock;